export default "__VITE_ASSET__518983b8__"